import { ActionsUnion, createAction } from "@redux/helpers";
import {
  UserListData,
  UserListPayload,
  UserListResponseData
} from "@type/index";

export const GET_USER_LIST = "[user list] get user list request";
const GET_USER_LIST_SUCCESS = "[user list] get user list success";
const GET_USER_LIST_LOADING = "[user list] get user list loading";
const SET_USER_LIST_NOFOUND = "[user list] set user list not found";

export const Actions = {
  getUserList: (payload: UserListPayload) =>
    createAction(GET_USER_LIST, payload),
  getUserListSuccess: (payload: UserListResponseData) =>
    createAction(GET_USER_LIST_SUCCESS, payload),
  getUserListLoading: (payload: boolean) =>
    createAction(GET_USER_LIST_LOADING, payload),
  setUserListNotFound: (payload: string) =>
    createAction(SET_USER_LIST_NOFOUND, payload)
};

type ActionType = ActionsUnion<typeof Actions>;

export type State = UserListData;

const initialState = {
  limit: 20,
  hasMore: false,
  errorCode: "",
  loading: true,
  total_users: 0,
  page: 1,
  users: [],
  style_gender: [],
  fetched_users: 0
};

export default (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case GET_USER_LIST:
      if (action.payload.page === 1) {
        return {
          ...initialState,
          loading: true,
          style_gender: action.payload.style_gender
        };
      }
      return state;
    case GET_USER_LIST_SUCCESS: {
      const _page = action.payload.page || 1;
      const _size = 20;
      const _total = action.payload.total_users || 0;
      const _rawUsers = action.payload.users || [];
      const _users = _rawUsers.filter(
        (user) => !!user.outfits && user.outfits.length > 0
      );

      return {
        ...state,
        page: action.payload.page,
        total_users: _total,
        users: _page === 1 ? _users : [...(state.users || []), ..._users],
        hasMore: _page * _size < _total,
        fetched_users:
          _page === 1
            ? _rawUsers.length
            : (state.fetched_users || 0) + _rawUsers.length,
        errorCode: "",
        loading: false
      };
    }
    case GET_USER_LIST_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case SET_USER_LIST_NOFOUND:
      return {
        ...state,
        errorCode: action.payload,
        hasMore: false,
        loading: false
      };
    default:
      return state;
  }
};
